module.exports = __webpack_public_path__ + "static/media/shift-left.85ab736d.svg";